export const version = 'kunde-v1.20.0-SNAPSHOT-9a1eafbca95a226a6f1d99a239cf57e536a9f953';